import { Maybe } from './schema/hannibal/types.generated';

export const formatName = (
  title?: Maybe<string>,
  firstName?: Maybe<string>,
  lastName?: Maybe<string>,
) => {
  const array = [title, firstName, lastName];
  return array.filter(value => !!value).join(' ');
};
